import Select, { Options } from 'ol/interaction/Select';

export const createCountryClickSelect = (options: Options = {}): Select => {
  return new Select(options);
};
